// Firebase Configuration and Initialization
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXDex_Jsh1hCk282IorZF7E4PWMZTG0lM",
  authDomain: "irms-app.firebaseapp.com",
  projectId: "irms-app",
  storageBucket: "irms-app.firebasestorage.app",
  messagingSenderId: "460007655651",
  appId: "1:460007655651:web:1f9f09061bdd44e0c59dd6",
  measurementId: "G-KXMP5WM2RV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
// Connect to the custom database "lancaster-asi" instead of default
export const db = getFirestore(app, "lancaster-asi");

export default app;
